import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyNumValidation {

  constructor() { }

  static ValidatePowerSupplyNum = (region: string) => {
    return (control: AbstractControl) => {
      if (control.value !== ''
        && control.value !== null
        && control.value !== undefined) {
        if (region === 'Boston Region' && (control.value.length > 5 || control.value.length < 3))
          return { validatePSNum: true }
      }
      return null;
    }
  }
}